import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const COLLAPSIBLE_GROUPS = {
  "Muestras y aprobaciones": [
    "__placeholder_muestras",
    "SMS comments",
    "SSS Fitting send",
    "SSS Fitting comments",
    "PP send",
    "Ok production Received",
    "Testing send to lab",
    "TOP sple send",
    "TOP approved",
  ],
  Producción: [
    "__placeholder_produccion",
    "Fabrics and trims In-house",
    "Production Starts",
  ],
  "Fechas críticas": [
    "__placeholder_fechas",
    "Inspection date",
    "ExFD",
    "ETDF",
    "CUT-OFF",
    "ETD",
    "DD",
  ],
  "Envío y logística": [
    "__placeholder_envio",
    "POReference",
    "PODate",
    "Factory",
    /*  "Remarks", */
    "NCartons",
    "GrossWeightKgs",
    "TotalVolumeCbm",
    "ShipmentMethod",
    "BookingDone",
    "Forwarder",
    "ShipmentCodeCustomer",
    "BLAWBNr",
    "ETA",
    "DocumentsApproved",
    "OriginalTelexDocsSemt",
  ],
};

const ColumnGroupRoot = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  overflow: "hidden",
});

const ColumnGroupTitle = styled("span")({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontWeight: 600,
  fontSize: "0.8rem",
});

const CollapsibleHeaderGroup = ({
  groupId,
  headerName,
  setColumnVisibilityModel,
}) => {
  const fields = COLLAPSIBLE_GROUPS[groupId];

  // 🧠 Hooks SIEMPRE FUERA de cualquier if
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem(`groupCollapsed_${groupId}`);
    return saved === "true"; // por defecto expandido
  });

  // 🔄 Guarda el estado en localStorage cada vez que cambia
  useEffect(() => {
    localStorage.setItem(`groupCollapsed_${groupId}`, isCollapsed);
  }, [isCollapsed, groupId]);

  // 📦 Aplica visibilidad según el estado colapsado (solo al cambiar isCollapsed, no en cada remount del grid).
  useEffect(() => {
    if (!fields) return;
    setColumnVisibilityModel((prev) => {
      const updated = { ...prev };
      let changed = false;
      for (const field of fields) {
        const visible = !isCollapsed;
        if (updated[field] !== visible) {
          updated[field] = visible;
          changed = true;
        }
      }
      return changed ? updated : prev;
    });
  }, [isCollapsed, fields, setColumnVisibilityModel]);

  const toggleGroupVisibility = () => {
    setIsCollapsed((prev) => !prev);
  };

  // 💡 Render condicional después de los hooks
  if (!fields) {
    return <ColumnGroupTitle>{headerName || groupId}</ColumnGroupTitle>;
  }

  return (
    <ColumnGroupRoot>
      <ColumnGroupTitle>{headerName || groupId}</ColumnGroupTitle>
      <IconButton size="small" onClick={toggleGroupVisibility}>
        {isCollapsed ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </ColumnGroupRoot>
  );
};

export default CollapsibleHeaderGroup;
